"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineUuids = void 0;
const uuid_1 = require("uuid");
const combineUuids = (uuid1, uuid2) => {
    let combinedUuid = undefined;
    if ([uuid1, uuid2].every(uuid_1.validate) && [uuid1, uuid2].every((id) => (0, uuid_1.version)(id) === 4)) {
        /** CHAT GPT */
        // Convert UUIDs to buffer
        const buffer1 = Buffer.from(uuid1.replace(/-/g, ''), 'hex');
        const buffer2 = Buffer.from(uuid2.replace(/-/g, ''), 'hex');
        // XOR the buffers
        const resultBuffer = Buffer.from(buffer1.map((byte, index) => byte ^ buffer2[index]));
        // Set the version bits to 4 for a Version 4 UUID
        resultBuffer[6] = (resultBuffer[6] & 0x0f) | 0x40;
        // Set the variant bits to 10
        resultBuffer[8] = (resultBuffer[8] & 0x3f) | 0x80;
        // Convert the result buffer to a UUID string
        const resultUUID = resultBuffer.toString('hex', 0, 16);
        // Insert dashes to format the UUID
        combinedUuid = resultUUID.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
    }
    return combinedUuid;
};
exports.combineUuids = combineUuids;
